/* Imagine Creation — Integrated Solutions
   - ภาพชั้นงาน "แยกตัว" เมื่อเลื่อนมาถึง (ไม่มี JS = แสดงแบบแยกตัวอยู่แล้ว)
   - hover / focus / แตะ รายการ → ไฮไลต์ชั้นในภาพ
   - theme editor: เลือก block แล้วไฮไลต์ชั้นนั้น */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setActive(root, i) {
    if (i) root.setAttribute('data-active', i); else root.removeAttribute('data-active');
    Array.prototype.forEach.call(root.querySelectorAll('.sol-row'), function (r) {
      r.classList.toggle('is-active', !!i && r.getAttribute('data-i') === String(i));
    });
  }

  function init(root) {
    if (!root || root.dataset.solInit) return;
    root.dataset.solInit = '1';
    var vis = root.querySelector('.sol-vis');

    if (vis && !reduce && 'IntersectionObserver' in window) {
      root.classList.add('js-anim');
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        setTimeout(function () { root.classList.add('is-open'); }, 120);
      }, { threshold: 0.25 });
      io.observe(vis);
    }

    var list = root.querySelector('.sol-list');
    Array.prototype.forEach.call(root.querySelectorAll('.sol-row'), function (row) {
      var i = row.getAttribute('data-i');
      row.addEventListener('mouseenter', function () { setActive(root, i); });
      row.addEventListener('focus', function () { setActive(root, i); });
      row.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        setActive(root, root.getAttribute('data-active') === i ? null : i);
      });
    });
    if (list) list.addEventListener('mouseleave', function () { setActive(root, null); });
  }

  function all() { Array.prototype.forEach.call(document.querySelectorAll('[data-ic-solutions]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();

  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-ic-solutions]')); });
  document.addEventListener('shopify:block:select', function (e) {
    var row = e.target.closest && e.target.closest('.sol-row');
    var root = row && row.closest('[data-ic-solutions]');
    if (root) { root.classList.add('is-open'); setActive(root, row.getAttribute('data-i')); }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest && e.target.closest('[data-ic-solutions]');
    if (root) setActive(root, null);
  });
})();
